import 'slick-carousel';
import pricingSteps from "../modules/pricing-steps";
import {CLASSES} from "../helpers/_global";

export function pricingPlatformSliders() {
  const $slider = $('.js-pricing-platform-slides');

  $slider.slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: false,
    dots: true,
    arrows: false,
  });

  $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
    const $pricingTargetSection = $('.js-pricing-target');
      $pricingTargetSection.removeClass(CLASSES.active);
  });
}

export function pricingPlatformDesktopInit() {
  const $pricingStepsSection = $('.js-pricing-steps-section');
  if($pricingStepsSection) {
    pricingSteps($pricingStepsSection);
  }
}

export function pricingPlatformMobileInit() {
  const $pricingTargetSection = $('.js-pricing-target');
  if($pricingTargetSection) {
    $pricingTargetSection.find('.js-pricing-target-head').on('click', () => {
    $pricingTargetSection.toggleClass(CLASSES.active);
    });
  }
}

export function pricingPlatformInit() {
  pricingPlatformDesktopInit();
  pricingPlatformMobileInit();
  pricingPlatformSliders();
}


